/// <reference types="./metadata.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Deprecated extends $CustomType {}

export class Errored extends $CustomType {}

export class System extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}

export class Developer extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}

export class User extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}

export class Tool extends $CustomType {
  constructor(content, tool_call_id) {
    super();
    this.content = content;
    this.tool_call_id = tool_call_id;
  }
}

export class Assistant extends $CustomType {
  constructor(content, context, tool_calls) {
    super();
    this.content = content;
    this.context = context;
    this.tool_calls = tool_calls;
  }
}

export class Context extends $CustomType {
  constructor(score, data_points_id) {
    super();
    this.score = score;
    this.data_points_id = data_points_id;
  }
}

export class FunctionCall extends $CustomType {
  constructor(id, name, arguments$) {
    super();
    this.id = id;
    this.name = name;
    this.arguments = arguments$;
  }
}

export function is_deprecated(metadata) {
  if (metadata instanceof Deprecated) {
    return true;
  } else if (metadata instanceof Errored) {
    return false;
  } else if (metadata instanceof System) {
    return false;
  } else if (metadata instanceof Developer) {
    return false;
  } else if (metadata instanceof User) {
    return false;
  } else if (metadata instanceof Tool) {
    return false;
  } else {
    return false;
  }
}

export function should_save(metadata) {
  if (metadata instanceof Deprecated) {
    return false;
  } else if (metadata instanceof Errored) {
    return true;
  } else if (metadata instanceof System) {
    return false;
  } else if (metadata instanceof Developer) {
    return false;
  } else if (metadata instanceof User) {
    return true;
  } else if (metadata instanceof Tool) {
    return true;
  } else {
    return true;
  }
}

export function should_send(metadata) {
  if (metadata instanceof Deprecated) {
    return false;
  } else if (metadata instanceof Errored) {
    return false;
  } else if (metadata instanceof System) {
    return false;
  } else if (metadata instanceof Developer) {
    return false;
  } else if (metadata instanceof User) {
    return true;
  } else if (metadata instanceof Tool) {
    return true;
  } else {
    return true;
  }
}

export function data_points_id(metadata) {
  if (metadata instanceof Assistant) {
    let $ = metadata.context;
    if ($ instanceof Some) {
      let context = $[0];
      return new Ok(context.data_points_id);
    } else {
      return new Error(undefined);
    }
  } else {
    return new Error(undefined);
  }
}

export function score(metadata) {
  if (metadata instanceof Assistant) {
    let $ = metadata.context;
    if ($ instanceof Some) {
      let context = $[0];
      return new Ok(context.score);
    } else {
      return new Error(undefined);
    }
  } else {
    return new Error(undefined);
  }
}

function tool_decoder() {
  return $decode.field(
    "content",
    $decode.string,
    (content) => {
      return $decode.field(
        "tool_call_id",
        $decode.string,
        (tool_call_id) => {
          return $decode.success(new Tool(content, tool_call_id));
        },
      );
    },
  );
}

function assistant_context_decoder() {
  return $decode.field(
    "score",
    $decode.float,
    (score) => {
      return $decode.field(
        "data_points_id",
        $decode.list($decode.string),
        (data_points_id) => {
          return $decode.success(new Context(score, data_points_id));
        },
      );
    },
  );
}

function function_call_decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.subfield(
        toList(["function", "name"]),
        $decode.string,
        (name) => {
          return $decode.subfield(
            toList(["function", "arguments"]),
            $decode.string,
            (arguments$) => {
              return $decode.success(new FunctionCall(id, name, arguments$));
            },
          );
        },
      );
    },
  );
}

function tool_call_decoder() {
  let default$ = new FunctionCall("", "", "");
  return $decode.field(
    "type",
    $decode.string,
    (kind) => {
      if (kind === "function") {
        return function_call_decoder();
      } else {
        return $decode.failure(default$, "ToolCall");
      }
    },
  );
}

function assistant_decoder() {
  return $decrypt.optional_field(
    "content",
    $decode.string,
    (content) => {
      return $decrypt.optional_field(
        "context",
        assistant_context_decoder(),
        (context) => {
          return $decrypt.optional_field(
            "tool_calls",
            $decode.list(tool_call_decoder()),
            (tool_calls) => {
              return $decode.success(
                new Assistant(content, context, tool_calls),
              );
            },
          );
        },
      );
    },
  );
}

export function decoder() {
  let content = $decode.at(toList(["content"]), $decode.string);
  return $decrypt.optional_field(
    "role",
    $decode.string,
    (role) => {
      if (role instanceof Some) {
        let $ = role[0];
        if ($ === "errored") {
          return $decode.success(new Errored());
        } else if ($ === "user") {
          return $decode.map(content, (var0) => { return new User(var0); });
        } else if ($ === "question") {
          return $decode.map(content, (var0) => { return new User(var0); });
        } else if ($ === "answer") {
          return $decode.map(
            content,
            (content) => {
              return new Assistant(new Some(content), new None(), new None());
            },
          );
        } else if ($ === "system") {
          return $decode.map(content, (var0) => { return new System(var0); });
        } else if ($ === "developer") {
          return $decode.map(content, (var0) => { return new Developer(var0); });
        } else if ($ === "tool") {
          return tool_decoder();
        } else if ($ === "assistant") {
          return assistant_decoder();
        } else {
          return $decode.failure(new Deprecated(), "Metadata");
        }
      } else {
        return $decode.success(new Deprecated());
      }
    },
  );
}

function content_encode(role, content) {
  return $json.object(
    toList([["role", $json.string(role)], ["content", $json.string(content)]]),
  );
}

function assistant_context_encode(context) {
  return $json.object(
    toList([
      ["score", $json.float(context.score)],
      ["data_points_id", $json.array(context.data_points_id, $json.string)],
    ]),
  );
}

function assistant_encode(content, context, tool_calls) {
  return $json.object(
    toList([
      ["role", $json.string("assistant")],
      ["content", $json.nullable(content, $json.string)],
      ["context", $json.nullable(context, assistant_context_encode)],
      [
        "tool_calls",
        $json.nullable(
          tool_calls,
          (calls) => {
            return $json.array(
              calls,
              (call) => {
                return $json.object(
                  toList([
                    ["type", $json.string("function")],
                    ["id", $json.string(call.id)],
                    [
                      "function",
                      $json.object(
                        toList([
                          ["name", $json.string(call.name)],
                          ["arguments", $json.string(call.arguments)],
                        ]),
                      ),
                    ],
                  ]),
                );
              },
            );
          },
        ),
      ],
    ]),
  );
}

function tool_encode(content, tool_call_id) {
  return $json.object(
    toList([
      ["role", $json.string("tool")],
      ["content", $json.string(content)],
      ["tool_call_id", $json.string(tool_call_id)],
    ]),
  );
}

export function encode(metadata) {
  if (metadata instanceof Deprecated) {
    return $json.object(toList([]));
  } else if (metadata instanceof Errored) {
    return $json.object(toList([["role", $json.string("errored")]]));
  } else if (metadata instanceof System) {
    let content = metadata.content;
    return content_encode("system", content);
  } else if (metadata instanceof Developer) {
    let content = metadata.content;
    return content_encode("developer", content);
  } else if (metadata instanceof User) {
    let content = metadata.content;
    return content_encode("user", content);
  } else if (metadata instanceof Tool) {
    let content = metadata.content;
    let tool_call_id = metadata.tool_call_id;
    return tool_encode(content, tool_call_id);
  } else {
    let content = metadata.content;
    let context = metadata.context;
    let tool_calls = metadata.tool_calls;
    return assistant_encode(content, context, tool_calls);
  }
}
